/**
 * Utility functions for working with cookies
 */

const TOKEN_COOKIE_NAME = 'access_token';

/**
 * Set a cookie
 */
export function setCookie(name: string, value: string, days: number = 7): void {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

/**
 * Get a cookie value
 */
export function getCookie(name: string): string | null {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

/**
 * Delete a cookie
 */
export function deleteCookie(name: string): void {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}

/**
 * Save access token to cookie
 */
export function saveToken(token: string): void {
  setCookie(TOKEN_COOKIE_NAME, token, 7);
}

/**
 * Get access token from cookie
 */
export function getToken(): string | null {
  return getCookie(TOKEN_COOKIE_NAME);
}

/**
 * Remove access token from cookie
 */
export function removeToken(): void {
  deleteCookie(TOKEN_COOKIE_NAME);
}

